import { z } from "zod";
import { AccrualExtractionBaseSchema } from "@common/schemas/financialDocument/invoice-extraction-record.schema";
import { InvoiceExtractionLineItemSchema } from "@common/schemas/financialDocument/invoice-extraction-line-item.schema";

export const BillExtractionBaseSchema = AccrualExtractionBaseSchema.omit({
    documentInvoicesExtractionId: true,
}).extend({
    documentBillsExtractionId: z.string().uuid(),
});

export type BillExtractionBase = z.infer<typeof BillExtractionBaseSchema>;

export const BillExtractionRecordSchema = AccrualExtractionBaseSchema.omit({
    documentInvoicesExtractionId: true,
    orderIndex: true,
}).extend({
    lineItems: z.array(InvoiceExtractionLineItemSchema).max(500),
});

export type BillExtractionRecord = z.infer<typeof BillExtractionRecordSchema>;
